module.exports = __webpack_public_path__ + "static/media/inspections-header@2x.e06bdfb5.jpg";